<template>
  <v-layout row justify-center>
    <div class="content-painting" >
      <div v-if="isAutorizado">
        <div v-if="lateral" class="custom-navigation">
          <button @click="isActive = !isActive">toggle custom navigation</button>
          <div v-if="debug">
            <pre>isActive: {{ isActive }}</pre>
            <pre>pintable: {{ !!$refs.paintable }}</pre>
          </div>
        </div>
        <div v-if="!savedFirma">
          <button v-if="printable" @click="$refs.paintable.clearCanvas">Borrar</button>
          <button v-if="printable" @click="$refs.paintable.saveCurrentCanvasToStorage">Guardar</button>
        </div>
        <div v-else>
          <button @click="reseteaFirma">Reiniciar Firma</button>
        </div>
        <paintable
          :active="isActive"
          :width="450"
          :height="200"
          :disableNavigation="disableNavigation"
          :hide="hidePaintable"
          :horizontalNavigation="true"
          :navigation="navigation"
          :name="isFirstPaintable ? 'mi-firma' : 'mi-segunda-firma'"
          :factor="1"
          :lineWidth="dynamicLineWidth"
          :lineWidthEraser="20"
          :useEraser="useEraser"
          :color="color"
          class="paint"
          ref="paintable"
          @toggle-paintable="toggledPaintable"
        ></paintable>
      </div>
      <div v-else-if="isProcesando">
        <h1 class="grey--text">Procesando...</h1>
        <p class="grey--text">
          Por favor, espere unos segundos mientras procesamos su información.
        </p>
      </div>
      <div v-else>
        <h1 class="red--text">¡ Ops !</h1>
        <h1 class="grey--text">Este enlace de firma ha caducado</h1>
        <p class="grey--text">
          Los links de firmas caducan en el momento en que se guarda su firma o son revocados por el emisor de dicho link.
        </p>
        <p class="blue--text">
          Por favor póngase en contacto con la persona que le envió este link de firma para que se lo vuelva a activar.
        </p>
      </div>
    </div>
  </v-layout>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { functions } from "@/components/firebase.js";
export default {
  data() {
    return {
      debug: false,
      isAutorizado: false,
      isProcesando: true,
      botonera: false,
      lateral: false,
      isFirstPaintable: true,
      hidePaintable: false,
      disableNavigation: true,
      dynamicLineWidth: 3,
      isActive: false,
      useEraser: false,
      color: "#32a0ef"
    };
  },
  mounted() {
    //   this.isActive = true;
    //   this.$refs.paintable.clearCanvas();
    // this.activar();
    this.checkToken();
  },
  computed: {
    ...mapGetters(["getUserUid", "savedFirma"]),
    token() {
      return this.$route.params.id;
    },
    coprop() {
      return this.$route.query.cp || false;
    },
    printable() {
      return this.botonera && this.$refs.paintable;
    },
    navigation() {
      return {
        "draw-save": {
          body: "click here!",
          activeBody: "<strong>save</strong>"
        },
        color: {
          body: "color"
        }
      };
    }
  },
  methods: {
    ...mapActions(["resetFirma"]),
    reseteaFirma() {
      // this.isProcesando = true;
      // this.isAutorizado = false;
      const payload = {
        uid: this.getUserUid,
        token: this.token,
        coprop: this.coprop
      };
      const reset = functions.httpsCallable("updateFirma");
      reset(payload)
        .then(data => {
          const datos = data.data;
          // eslint-disable-next-line no-console
          console.log(datos);
          if (datos.success) {
            this.resetFirma(payload);
            // this.isProcesando = false;
            // this.isAutorizado = true;
            // this.activar();
            console.log('Ahora eliminar el dibujo...')
            this.$refs.paintable.clearCanvas;
          }
        })
        .catch(error => {
          // eslint-disable-next-line no-console
          this.isAutorizado = false;
          this.isProcesando = false;
          console.log(error);
        });
    },
    activar() {
      // this.toggledPaintable(true);
      this.isActive = true;
      setTimeout(() => {
        this.botonera = true;
      }, 500);
      console.log(`El Token es: ${this.token}`);
      console.log(`El Co-Propietario es: ${this.coprop}`);
      /* this.isActive = false;
        this.isActive = true; */
    },
    checkToken() {
      if (!this.token) {
        return null;
      }
      const payload = {
        uid: this.getUserUid,
        token: this.token,
        coprop: this.coprop
      };
      console.log(payload);
      // return;
      const check = functions.httpsCallable("checkTokenFirma");
      check(payload)
        .then(data => {
          let datos = data.data;
          console.log(datos);
          if (datos.success) {
            this.isAutorizado = true;
            this.isProcesando = false;
            this.activar();
          } else {
            this.isProcesando = false;
          }
        })
        .catch(error => {
          // eslint-disable-next-line no-console
          console.log(error);
          this.isProcesando = false;
        });
    },
    navigate() {
      this.isFirstPaintable = !this.isFirstPaintable;
    },
    hide() {
      this.$hidePaintableNavigation();
    },
    show() {
      this.$showPaintableNavigation();
    },
    toggledPaintable(isActive) {
      this.isActive = isActive;
    }
  }
};
</script>

<style scoped>
body {
  font-family: Helvetica, Arial, sans-serif;
  position: initial !important;
}
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 0px;
}
.content-painting {
  margin-top: 10px;
}
h3 {
  font-weight: normal;
}
.control {
  margin: 20px;
}
.paint {
  border: 3px solid #000;
  border-radius: 10px;
  margin: 40px auto;
  box-sizing: border-box;
  display: block;
  width: 460px !important;
  height: 210px !important;
  position: relative !important;
  overflow: hidden;
}
footer {
  text-align: center;
}
footer a {
  color: #777;
  text-transform: uppercase;
  text-decoration: none;
}
button {
  border: 0;
  margin: 0 10px 0 0;
  font-size: 14px;
  padding: 10px 15px;
  opacity: 0.8;
  background-color: rgb(19, 102, 141);
  border-radius: 3px;
  color: #fff;
  cursor: pointer;
}
button:hover {
  opacity: 1;
}
.custom-navigation {
  position: fixed;
  top: 40px;
  left: 40px;
  z-index: 1001;
  background-color: #fff;
}
.custom-navigation .controls {
  margin: 10px 0 0 0;
  border: 1px solid #ddd;
  padding: 20px;
  border-radius: 5px;
}
</style>
